<div class="floating-button-container ">
  <div class="floating-button justify-content-between" *ngIf="showButton">
    <p class="enjoying-text">Enjoying Hunch?</p>
    <p class="download-button" (click)="downloadApp()">Download Now</p>
  </div>
</div>